import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Input, InputLabel } from "@mui/material";
import React, { useRef } from "react";

const CompanyAddUsecureModal = (props) => {

	const externalId = useRef(null);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmit = () => {
		const usecureRequest = {
			externalId: externalId.current.value,
			companyId: props.company.id
		};
		props.onSubmit(usecureRequest);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose();
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em 10%"
	};
	
	return (
		<Dialog
			open={props.company}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Add usecure for {props.company? props.company.name : ""}
			</DialogTitle>
			<DialogContent>
				<form onSubmit={handleSubmitForm} autoComplete="off">
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="externalId">External ID</InputLabel>
						<Input inputRef={externalId} id="externalId"/>
					</FormControl>
				</form>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleSubmit} autoFocus>Submit</Button>
			</DialogActions>
		</Dialog>
	);

}

export default CompanyAddUsecureModal;